import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=72d7546d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=72d7546d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7546d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d7546d')) {
      api.createRecord('72d7546d', component.options)
    } else {
      api.reload('72d7546d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=72d7546d&scoped=true&", function () {
      api.rerender('72d7546d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28UhMlq8SYZHa/JS/comp/PopupDialog.vue"
export default component.exports